var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCpLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_72",
    "data-name": "Group 72",
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.184,
    height: 30.329,
    viewBox: "0 0 64.184 30.329",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M3336.161,3356.6q-5.865,0-5.867-5.866a4.218,4.218,0,0,1,.861-2.76,2.724,2.724,0,0,1,2.191-1.05,2.646,2.646,0,0,1,2.142.848,3.219,3.219,0,0,1,.712,2.155,2.054,2.054,0,0,1-.744,1.646,2.538,2.538,0,0,1-1.687.631,2.8,2.8,0,0,1-.843-.144l-.4-.293c-.131.032-.221.193-.271.487a2.505,2.505,0,0,0-.022.78,2.954,2.954,0,0,0,1.321,2.124,5,5,0,0,0,2.588.609l.014.834Z",
    transform: "translate(-3325.014 -3340.132)",
    fill: "#2c3c46"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M3352.954,3364.464q-10.633,0-10.633-10.632a7.631,7.631,0,0,1,1.565-5.005,4.927,4.927,0,0,1,3.977-1.9,4.8,4.8,0,0,1,3.887,1.533,5.842,5.842,0,0,1,1.294,3.909,3.734,3.734,0,0,1-1.348,2.985,4.592,4.592,0,0,1-3.053,1.141,5.061,5.061,0,0,1-1.529-.262l-.717-.528c-.234.059-.4.356-.487.884a4.624,4.624,0,0,0-.045,1.416,5.385,5.385,0,0,0,2.389,3.851,9.044,9.044,0,0,0,4.7,1.1l0,1.506Z",
    transform: "translate(-3330.417 -3340.132)",
    fill: "#2c3c46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M3335.873,3336.2a13.559,13.559,0,1,1-13.559,13.559,13.575,13.575,0,0,1,13.559-13.559m0-1.6a15.164,15.164,0,1,0,15.165,15.164,15.166,15.166,0,0,0-15.165-15.164",
    transform: "translate(-3320.708 -3334.594)",
    fill: "#2c3c46"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_70",
    "data-name": "Group 70",
    transform: "translate(35.938 8.617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M3390.308,3350.658l-.433.869a1.562,1.562,0,0,0-1.137-.352,1.467,1.467,0,0,0-1.218.622,2.523,2.523,0,0,0-.473,1.574,2.382,2.382,0,0,0,.442,1.511,1.415,1.415,0,0,0,1.173.559,1.575,1.575,0,0,0,1.312-.6l.491.852a2.472,2.472,0,0,1-1.889.686,2.381,2.381,0,0,1-1.93-.816,3.377,3.377,0,0,1-.69-2.237,3.244,3.244,0,0,1,.762-2.2,2.482,2.482,0,0,1,1.957-.889,2.831,2.831,0,0,1,1.632.42",
    transform: "translate(-3385.956 -3350.238)",
    fill: "#2c3c46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M3399.035,3356.309l-1.582-2.452c-.158,0-.384-.014-.668-.027v2.479h-1.1v-5.934c.058,0,.289-.01.685-.032s.717-.031.96-.031q2.26,0,2.259,1.749a1.629,1.629,0,0,1-.311.96,1.689,1.689,0,0,1-.784.614l1.754,2.673Zm-2.254-5.018v1.651c.194.018.342.023.446.023a1.932,1.932,0,0,0,.965-.186.784.784,0,0,0,.307-.726.63.63,0,0,0-.33-.613,2.292,2.292,0,0,0-1.032-.176,2.4,2.4,0,0,0-.356.027",
    transform: "translate(-3390.329 -3350.271)",
    fill: "#2c3c46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M3404.376,3353.26a3.345,3.345,0,0,1,.694-2.147,2.242,2.242,0,0,1,1.857-.875,2.436,2.436,0,0,1,1.957.794,3.334,3.334,0,0,1,.677,2.228,3.422,3.422,0,0,1-.708,2.277,2.471,2.471,0,0,1-2.006.844,2.18,2.18,0,0,1-1.835-.834,3.7,3.7,0,0,1-.635-2.286m1.091,0a3.1,3.1,0,0,0,.352,1.614,1.129,1.129,0,0,0,1.024.573,1.4,1.4,0,0,0,1.2-.559,2.717,2.717,0,0,0,.415-1.623c0-1.389-.514-2.088-1.538-2.088a1.23,1.23,0,0,0-1.082.564,2.715,2.715,0,0,0-.375,1.52",
    transform: "translate(-3394.231 -3350.238)",
    fill: "#2c3c46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M3419.788,3356.442h-.432l-1.3-3.742-1.258,3.742h-.437l-1.948-6.015h1.1l1.113,3.581,1.2-3.581h.46l1.209,3.581,1.109-3.581h1.1Z",
    transform: "translate(-3398.739 -3350.323)",
    fill: "#2c3c46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M3430.114,3356.328H3428.8V3350.4c.839-.031,1.366-.045,1.583-.045a2.78,2.78,0,0,1,2.056.758,2.723,2.723,0,0,1,.758,2.016q0,3.2-3.08,3.2m-.266-5.01v4.05a5.479,5.479,0,0,0,.55.022,1.493,1.493,0,0,0,1.249-.582,2.579,2.579,0,0,0,.451-1.619c0-1.271-.59-1.9-1.772-1.9a4.778,4.778,0,0,0-.478.031",
    transform: "translate(-3405.2 -3350.29)",
    fill: "#2c3c46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M3387.9,3366.777v2.183h-1.055v-5.929c.7-.032,1.113-.046,1.231-.046a3.794,3.794,0,0,1,2.056.433,1.5,1.5,0,0,1,.649,1.348q0,2.042-2.408,2.043c-.117-.005-.275-.014-.473-.032m0-2.836v1.9q.27.027.419.027a1.845,1.845,0,0,0,1.055-.238.911.911,0,0,0,.333-.785c0-.618-.5-.925-1.488-.925a2.417,2.417,0,0,0-.32.023",
    transform: "translate(-3386.353 -3355.963)",
    fill: "#2c3c46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M3395.4,3365.892a3.348,3.348,0,0,1,.694-2.146,2.245,2.245,0,0,1,1.858-.875,2.437,2.437,0,0,1,1.957.793,3.331,3.331,0,0,1,.677,2.228,3.422,3.422,0,0,1-.708,2.277,2.473,2.473,0,0,1-2.006.843,2.18,2.18,0,0,1-1.835-.834,3.7,3.7,0,0,1-.636-2.286m1.091,0a3.1,3.1,0,0,0,.352,1.615,1.138,1.138,0,0,0,1.024.572,1.4,1.4,0,0,0,1.2-.559,2.713,2.713,0,0,0,.415-1.623c0-1.389-.514-2.088-1.538-2.088a1.229,1.229,0,0,0-1.082.564,2.722,2.722,0,0,0-.374,1.52",
    transform: "translate(-3390.196 -3355.913)",
    fill: "#2c3c46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M3406.726,3368.993v-5.934h1.055v5h2.683v.934Z",
    transform: "translate(-3395.286 -3355.997)",
    fill: "#2c3c46"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    width: 1.055,
    height: 5.934,
    transform: "translate(16.17 7.062)",
    fill: "#2c3c46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M3423.533,3363.293l-.433.87a1.558,1.558,0,0,0-1.136-.352,1.464,1.464,0,0,0-1.218.622,2.52,2.52,0,0,0-.474,1.573,2.354,2.354,0,0,0,.442,1.511,1.42,1.42,0,0,0,1.173.559,1.574,1.574,0,0,0,1.312-.6l.491.852a2.473,2.473,0,0,1-1.889.686,2.38,2.38,0,0,1-1.934-.821,3.357,3.357,0,0,1-.69-2.232,3.244,3.244,0,0,1,.762-2.2,2.458,2.458,0,0,1,1.952-.883,2.836,2.836,0,0,1,1.641.415",
    transform: "translate(-3400.879 -3355.917)",
    fill: "#2c3c46"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M3431.129,3366.558v2.435h-1.055v-2.435l-2-3.5h1.118l1.4,2.529,1.412-2.529h1.114Z",
    transform: "translate(-3404.877 -3355.997)",
    fill: "#2c3c46"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpLogo);
export default __webpack_public_path__ + "static/media/cp-logo.251a752a0b4bc6cca84344dfcadb1457.svg";
export { ForwardRef as ReactComponent };